<template>
  <div class="login">
    <div class="frow centered">
      <div class="box">
        <label class="label">
          Username:
        </label>
        <input
          v-model="username"
          class="input"
          type="text"
          placeholder="Username"
        >
        <br>
        <br>
        <label class="label">
          Password:
        </label>
        <input
          v-model="password"
          class="input"
          type="password"
          placeholder="Password"
        >
        <br>
        <br>
        <button
          class="button"
          @click="login"
        >
          Login
        </button>
        <br>
        <br>
        <router-link to="/admin/forgot-password">
          Forgot Password
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      username: '',
      password: '',
    };
  },
  computed: {
    API() {
      return this.$API;
    },
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push('/admin/stories');
    }
  },
  methods: {
    login() {
      this.axios
        .post(`${this.$API}/auth/local`, {
          identifier: this.username,
          password: this.password,
        })
        .then((response) => {
          this.$store.commit('login', response.data);
          console.log('User profile', response.data.user);
          console.log('User token', response.data.jwt);
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  background-color: #fff;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.box {
  height: 300px;
  width: 300px;
}
</style>
